import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TaskTableHeader from './components/task-header.vue';
import TableHeader from './components/table-header.vue';
import { getTaskList } from '@blade/common/api/bulk-import';
let default_1 = class extends Vue {
    dataSource = [];
    taskId = '';
    loading = false;
    pagination = { page: 1, size: 10, total: 0 };
    state = '';
    imageName = '';
    get filterTaskStatus() {
        return [
            { text: this.$t('normal'), value: 'SUCCESS' },
            { text: this.$t('error'), value: 'FAIL' },
        ];
    }
    // filterTaskStatusTag(value: any, row: any) {
    //   return row.state === value;
    // }
    handlePagination(value) {
        this.pagination.page = value;
        this.getTaskList();
    }
    handleSizeNavigation(value) {
        this.pagination.size = value;
        this.getTaskList();
    }
    handleSearch(val) {
        this.imageName = val;
        this.getTaskList();
    }
    getTaskList() {
        this.loading = true;
        const reqParam = {
            page: this.pagination.page,
            size: this.pagination.size,
            imageName: this.imageName,
            taskId: this.taskId,
        };
        const res = this.state ? { ...reqParam, state: this.state } : { ...reqParam };
        getTaskList({ ...res })
            .then((re) => {
            this.loading = false;
            this.pagination.total = re.data.data.total;
            this.dataSource = re.data.data.list;
        })
            .catch((error) => {
            this.loading = false;
            this.$elmessage.error(error.data?.message);
        });
    }
    mounted() {
        const id = this.$route.params.id;
        console.log('res:', id);
        this.taskId = id;
        this.getTaskList();
    }
    handleFilter(val) {
        console.log('val:', val);
        this.pagination.page = 1;
        const currFilter = val['status'][0];
        this.state = currFilter;
        this.getTaskList();
    }
};
default_1 = __decorate([
    Component({
        name: 'PhotoList',
        components: { 'task-header': TaskTableHeader, TableHeader },
        i18n: {
            messages: {
                'en-us': {
                    id: 'Id',
                    label: 'label',
                    account: 'Account',
                    creator: 'Created By',
                    updateTime: 'Updated Time',
                    percent: 'Valid/All',
                    status: 'Status',
                    actions: 'Operation',
                    edit: 'Edit',
                    delete: 'Delete',
                    pic: 'Picture Names',
                    name: 'Name',
                    idType: 'IDType',
                    portrait: 'Portrait',
                    normal: 'Success',
                    error: 'Fail ',
                },
                zh: {
                    id: 'ID',
                    label: '命名',
                    account: '账号',
                    pic: '图片名称',
                    creator: '创建人',
                    updateTime: '更新时间',
                    percent: '有效人像/总人像',
                    status: '状态',
                    actions: '操作',
                    edit: '编辑',
                    delete: '删除',
                    name: '姓名',
                    idType: 'IDType',
                    portrait: '人像',
                    normal: '成功',
                    error: '失败 ',
                },
            },
        },
    })
], default_1);
export default default_1;
